<!-- SERVICE UNAVAILBLE (user has upcoming trips but the information is currently not available ) -->
<div *ngIf="showServiceUnavailableMessage">
  <div
    class="travel-modes-container w-two-thirds-ns flex items-center flex-column center b br3 bg-off-white pv4 ph3 ph4-ns mv6"
  >
    <img [src]="copy.errorMessage[0]?.errorImage[0]?.src" class="pb4" />
    <div class="m-heading fw4 pb4 mb0 tc">
      {{ copy.errorMessage[0]?.errorHeadline }}
    </div>
    <div class="body pb4 tc">{{ copy.errorMessage[0]?.errorCopy }}</div>
    <a
      jbActionLink
      href="{{ copy.errorMessage[0]?.errorCTA[0]?.href }}"
      target="{{ copy.errorMessage[0]?.errorCTA[0]?.newWindow }}"
      id="action-link-cta-manage-trips"
    >
      <span>{{ copy.errorMessage[0]?.errorCTA[0]?.title }}</span>
      <jb-icon class="pl1" name="rightFilled"></jb-icon>
    </a>
  </div>
</div>
<!-- SERVICE UNAVAILBLE ends -->

<div *ngIf="upcomingTripData.length">
  <div class="travel-modes-container flex items-center flex-column center">
    <h2
      class="ma0 flex self-center mb5 mt8 core-blue tc book"
      id="travel-modes-heading"
    >
      {{ copy.heading }}
      <ng-container *ngIf="segmentDestination"
        >{{ copy.to }} <br />{{ segmentDestination }}</ng-container
      >
    </h2>

    <!-- starts main block -->
    <ng-container *ngFor="let trip of upcomingTripData; let i = index">
      <div
        class="mb5 w-100 mw6-ns klarheit b br3 bg-white {{
          legAttributes[i].statusColor
        }}"
      >
        <ng-container *ngFor="let leg of trip.airLegList; let j = index">
          <div *ngIf="j === activeIndex">
            <!-- Top section  contains Flight, Date, Confirmation -->
            <div class="w-100 flex justify-around pv4 ph4">
              <div
                class="w-third max-width-one-third flex flex-column items-center"
              >
                <div class="w-auto legal items-center">
                  {{ copy.flight }}
                </div>
                <span class="db dib-l body-demi fw8">{{
                  leg.flightInfo[0].flightNumber
                }}</span>
              </div>
              <div
                class="w-third max-width-one-third flex flex-column items-center"
              >
                <div class="legal">
                  {{ copy.date }}
                </div>
                <span class="db dib-l body-demi fw8">{{
                  leg.flightInfo[0].date | jbDate: 'MMM d'
                }}</span>
              </div>
              <div
                class="w-third max-width-one-third flex flex-column items-center"
              >
                <div class="legal">
                  {{ copy.confirmation }}
                </div>
                <span class="db dib-l body-demi fw8">{{
                  upcomingTripData[0].pnr
                }}</span>
              </div>
            </div>

            <!-- Middle section contains Origin, Status , Destination -->
            <div
              class="flex justify-around w-100 pb4 ph4 s-body"
              [ngClass]="{
                'center-ns pl5-ns pl0-m':
                  !legAttributes[i].displayTimes ||
                  legAttributes[i].statusColor === 'cancelled-status'
              }"
            >
              <!-- Departing from  -->
              <div
                class="flex flex-column items-center justify-between w-third max-width-one-third"
              >
                <div class="s-body mw-100 truncateOverflow tc">
                  {{ legAttributes[i]?.originCity }}
                </div>
                <div class="core-blue f4 l-body pv1 mb0 fw8">
                  {{ leg.origin }}
                </div>
                <ng-container
                  *ngIf="
                    legAttributes[i].showTerminalGate &&
                    legAttributes[i].statusColor !== 'cancelled-status'
                  "
                >
                  <div>
                    {{ copy.terminal }}:
                    <span class="fw6">{{
                      leg.flightInfo[0].originTerminal
                        ? leg.flightInfo[0].originTerminal
                        : '-'
                    }}</span>
                  </div>
                  <div>
                    {{ copy.gate }}:
                    <span class="fw6">{{
                      leg.flightInfo[0].originGate
                        ? leg.flightInfo[0].originGate
                        : '-'
                    }}</span>
                  </div>
                </ng-container>
              </div>

              <!-- Status and Icon -->
              <!-- ARROW ICON  -->
              <div
                class="flex flex-column justify-center items-center pt4 w-third max-width-one-third"
              >
                <div class="mb2">
                  <jb-icon
                    class="fill-medium-gray"
                    name="flightCityConnectorArrow"
                  ></jb-icon>
                </div>
                <!-- STATUS -->
                <!-- status available  -->
                <div
                  *ngIf="
                    leg?.flightInfo[0]?.flightStatus &&
                    leg.flightInfo[0].operatedBy == 'B6'
                  "
                  class="flex flex-row items-center s-body"
                >
                  <div
                    class="status-dot {{
                      legAttributes[i].statusColor
                    }} dib br-100 mr1"
                  ></div>
                  <div class="lower-case fw6">
                    {{ (leg?.flightInfo)[0]?.flightStatus }}
                  </div>
                </div>
                <!-- Operated by JetBlue and status unavailable (if status unavailable and not operated by JetBlue - do not display div) -->
                <div
                  *ngIf="
                    !leg?.flightInfo[0]?.flightStatus &&
                    leg.flightInfo[0].operatedBy == 'B6'
                  "
                  class="flex flex-column items-center s-body"
                >
                  <div class="capitalize fw6">{{ copy.flightStatus }}</div>
                  <div class="lower-case fw6">{{ copy.unavailable }}</div>
                </div>
                <!-- OPERATED BY -->
                <div
                  class="operatedBy w-100 flex flex-column tc legal"
                  *ngIf="leg.flightInfo[0].operatedBy !== 'B6'"
                >
                  <div>{{ copy.operatedBy }}:</div>
                  <div>{{ leg.flightInfo[0].airlinesName }}</div>
                </div>
              </div>

              <!-- Arriving at -->
              <div
                class="flex flex-column items-center justify-between w-third max-width-one-third"
              >
                <div class="location-name s-body truncateOverflow tc">
                  {{ legAttributes[i].destinationCity }}
                </div>
                <div class="core-blue f4 pv1 l-body mb0 fw8">
                  {{ leg.destination }}
                </div>
                <ng-container
                  *ngIf="
                    legAttributes[i].showTerminalGate &&
                    legAttributes[i].statusColor !== 'cancelled-status'
                  "
                >
                  <div>
                    {{ copy.terminal }}:
                    <span class="fw6">{{
                      leg.flightInfo[0].destinationTerminal
                        ? leg.flightInfo[0].destinationTerminal
                        : '-'
                    }}</span>
                  </div>
                  <div>
                    {{ copy.gate }}:
                    <span class="fw6">{{
                      leg.flightInfo[0].destinationGate
                        ? leg.flightInfo[0].destinationGate
                        : '-'
                    }}</span>
                  </div>
                </ng-container>
              </div>
            </div>
            <!-- end of middle section -->

            <!-- Bottom section contains Boards, Doors close, Departs, Arrives -->
            <div
              *ngIf="
                legAttributes[i].displayTimes &&
                legAttributes[i].statusColor !== 'cancelled-status'
              "
              class="w-100 ph4"
              [ngClass]="{
                'justify-around': legAttributes[i].hasDeparted,
                'justify-between': !legAttributes[i].hasDeparted
              }"
            >
              <div class="flex justify-between w-100 pt3 pb4 section-divider">
                <!-- Boarding  -->
                <div
                  class="flex flex-column items-center legal"
                  [ngClass]="{
                    b:
                      legAttributes[i].statusColor === 'delayed-status' ||
                      legAttributes[i].statusColor === 'boarding-status'
                  }"
                >
                  <div class="db-l legal">{{ copy.boarding }}</div>
                  <div class="nowrap body">
                    {{
                      leg.flightInfo[0].boardingTime != null
                        ? (leg.flightInfo[0].boardingTime | date: 'shortTime')
                        : '-'
                    }}
                  </div>
                </div>

                <!-- Doors close -->
                <div
                  class="flex flex-column items-center"
                  [ngClass]="{
                    b:
                      legAttributes[i].statusColor === 'delayed-status' ||
                      legAttributes[i].statusColor === 'closing-status'
                  }"
                >
                  <span class="db-l legal">
                    <ng-container
                      *ngIf="legAttributes[i].statusColor === 'closing-status'"
                      >{{ copy.doorsClosing }}</ng-container
                    >
                    <ng-container
                      *ngIf="legAttributes[i].statusColor !== 'closing-status'"
                      >{{ copy.doorsClose }}</ng-container
                    >
                  </span>
                  <span class="db nowrap body">{{
                    leg.flightInfo[0].doorClosingTime != null
                      ? (leg.flightInfo[0].doorClosingTime | date: 'shortTime')
                      : '-'
                  }}</span>
                </div>

                <!-- Departs -->
                <div class="flex flex-column items-center">
                  <div
                    class="flex flex-column items-center legal"
                    [ngClass]="{
                      b:
                        leg.flightInfo[0].estimatedDepartureTime >
                        leg.flightInfo[0].scheduledDepartureTime
                    }"
                  >
                    <span class="db-l" *ngIf="!legAttributes[i].hasDeparted">{{
                      copy.departs
                    }}</span>
                    <span class="db-l" *ngIf="legAttributes[i].hasDeparted">{{
                      copy.departed
                    }}</span>

                    <span class="db w-100 nowrap body">{{
                      leg.flightInfo[0].estimatedDepartureTime ||
                        leg.flightInfo[0].scheduledDepartureTime
                        | date: 'shortTime'
                    }}</span>
                  </div>

                  <div
                    *ngIf="
                      leg.flightInfo[0].estimatedDepartureTime >
                      leg.flightInfo[0].scheduledDepartureTime
                    "
                    class="flex-l w-100-l items-baseline-l justify-between-l"
                  >
                    <span class="db w-100 body legal"
                      >{{ copy.was }}
                      {{
                        leg.flightInfo[0].scheduledDepartureTime
                          | date: 'shortTime'
                      }}</span
                    >
                  </div>
                </div>

                <!-- Arrives -->
                <div class="b3-l flex flex-column items-center">
                  <div
                    class="flex flex-column items-center legal"
                    [ngClass]="{
                      b:
                        leg.flightInfo[0].estimatedArrivalTime >
                        leg.flightInfo[0].scheduledArrivalTime
                    }"
                  >
                    <span class="db-l" *ngIf="!legAttributes[i].hasArrived">{{
                      copy.arrives
                    }}</span>
                    <span class="db-l" *ngIf="legAttributes[i].hasArrived">{{
                      copy.arrived
                    }}</span>

                    <span class="db w-100 nowrap body">{{
                      leg.flightInfo[0].estimatedArrivalTime ||
                        leg.flightInfo[0].scheduledArrivalTime
                        | date: 'shortTime'
                    }}</span>
                  </div>

                  <div
                    *ngIf="
                      leg.flightInfo[0].estimatedArrivalTime >
                      leg.flightInfo[0].scheduledArrivalTime
                    "
                    class="flex-l w-100-l items-baseline-l justify-between-l"
                  >
                    <span class="db tr-l w-100 legal"
                      >{{ copy.was }}
                      {{
                        leg.flightInfo[0].scheduledArrivalTime
                          | date: 'shortTime'
                      }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
            <!-- end of bottom section -->
          </div>
        </ng-container>

        <div *ngIf="trip.airLegList.length > 1" class="flex items-center pb4">
          <jb-paginator
            class="center"
            [length]="trip.airLegList.length"
            [pageIndex]="activeIndex"
            [statusCaption]="myStatusCaption"
            nextCaption="Click to select next item. "
            previousCaption="Click to select previous item. "
            (pageEvent)="handlePaginatorEvent($event)"
          >
          </jb-paginator>
        </div>
        <!-- bottom button -->
        <div
          class="flex justify-center w-100 ph4 pb4"
          *ngIf="manageBookingLink | async as bookingLink"
        >
          <a
            [jbSitemapLinker]="bookingLink"
            jbButton
            theme="ctaPrimary"
            [isPaired]="false"
            [isRounded]="true"
            [isFull]="true"
          >
            {{ copy.manageTrips }}
          </a>
        </div>
      </div>
    </ng-container>

    <!-- ends main block -->
  </div>
</div>
